import { lazy } from 'react';
import PageView from './PageView';

const InternalUserPage = lazy(() => import('src/pages/internalUser'));

export const internalUserRoutes = [
  {
    path: 'internal-user',
    element: <PageView permission="BO_CAN_VIEW_USERS" />,
    children: [{ element: <InternalUserPage />, index: true }],
  },
];
